import { useQuery } from '@tanstack/react-query'
import { api, queryKeys } from '@/lib/api'
import type { Team } from '@/types'

interface UseAgentTeamsOptions {
  enabled?: boolean
}

export function useAgentTeams(options: UseAgentTeamsOptions = {}): {
  teams: Team[]
  isLoading: boolean
  isFetching: boolean
  error: Error | null
  refetch: () => Promise<any>
} {
  const { enabled = true } = options

  const queryResult = useQuery({
    queryKey: queryKeys.agentTeams.list(),
    enabled,
    queryFn: async () => {
      const response = await api.agent.getTeams()

      if (!response.success) {
        throw new Error(response.error || 'Failed to load teams')
      }

      if (!Array.isArray(response.data)) {
        return []
      }

      return response.data
    },
  })

  return {
    teams: queryResult.data ?? [],
    isLoading: queryResult.isLoading,
    isFetching: queryResult.isFetching,
    error: (queryResult.error as Error) ?? null,
    refetch: queryResult.refetch,
  }
}
